<template>
  <div>
    <div class="modal fade show custom-modal" id="premiumBreakdown" role="dialog" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-size">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title ml-4 pl-1 float-left font-weight-bold base-premium">Premium Breakdown</h5>
            <button type="button" class="close" data-dismiss="modal" @click="breakdownModal()" id="premium-breakdown-cross-close">
              <img src="@/assets/images/popup-close.png" alt="X" />
            </button>
          </div>
          <div class="border-divison ml-3">
            <div class="style-border mt-1"/>
          </div>
          <div class="modal-body mt-4 pb-0">
            <div class="row mr-0">
              <div class="col-2">
                <p class="base-premium premium-size">Breakdowns</p>
              </div>
              <div class="col-4 pl-5 ">
                <p class="base-premium premium-size text-ellipsis">Before Endorsement</p>
              </div>
              <div class="col-4">
                <p class="base-premium premium-size text-ellipsis">After Endorsement</p>
              </div>
              <div class="col-2">
                <p class="base-premium premium-size">Change</p>
              </div>
            </div>
            <hr class='rule my-0 '>
            <div class="row mr-0">
               <div class="col-2 mt-3">
                <p class="premium">BASE PREMIUM</p>
              </div>
              <div class="col-4 pl-5 mt-3 responsive">
                <p class="font-weight-bold mb-0">₹ {{calcbasePremium.premium.premiumBreakup.basePremium == '' ? '0' : calcbasePremium.premium.premiumBreakup.basePremium}}</p>
                <p class="mb-0 mt-2">sgst <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.sgst == '' ? '0' : calcbasePremium.premium.premiumBreakup.sgst}}</span></p>
                <p class="mb-0">cgst <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.cgst == '' ? '0' : calcbasePremium.premium.premiumBreakup.cgst}}</span></p>
                <p class="mb-0">Discount <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.discount == '' ? '0' : calcbasePremium.premium.premiumBreakup.discount}}</span></p>
                <p class="">Loading <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.loading == '' ? '0' : calcbasePremium.premium.premiumBreakup.loading}}</span></p>
              </div>
               <div class="col-4 mt-3  responsive">
                <p class="font-weight-bold mb-0">₹ {{premcalcDetail.basicPremium == '' ? '0' : premcalcDetail.basicPremium}}</p> 
                <p class="mb-0 mt-2">sgst <span class="font-weight-bold">{{taxDetails.sgst == '' ? '0' : taxDetails.sgst}}</span></p>
                <p class="mb-0">cgst <span class="font-weight-bold">{{taxDetails.cgst == '' ? '0' : taxDetails.cgst}}</span></p>
                <p class="mb-0">Discount <span class="font-weight-bold">{{premcalcDetail.discretionaryDiscount == '' ? '0' : premcalcDetail.discretionaryDiscount}}</span></p>
                <p class="">Loading <span class="font-weight-bold">{{premcalcDetail.discretionaryLoading == '' ? '0' : premcalcDetail.discretionaryLoading}}</span></p>
              
              </div>
               <div class="col-2 mt-2 background rounded-background-top  responsive">
               <P class="font-weight-bold mt-2 mb-0">₹ {{parseInt(premcalcDetail.basicPremium)>parseInt(calcbasePremium.premium.premiumBreakup.basePremium) ? (premcalcDetail.basicPremium)-(calcbasePremium.premium.premiumBreakup.basePremium) : (calcbasePremium.premium.premiumBreakup.basePremium)-(premcalcDetail.basicPremium)}}</P>
              </div>

            </div>
            <hr class="dash  my-0">
            <div class="row mr-0">
              <div class="col-2 mt-1">
                <p class="premium mt-2">NET PREMIUM</p>
              </div>
              <div class="col-4 pl-5 mt-1 responsive">
                <p class="font-weight-bold mt-2">₹ {{calcbasePremium.premium.premiumBreakup.grossPremium == '' ? '0' : calcbasePremium.premium.premiumBreakup.grossPremium}}</p>
              </div>
              <div class="col-4 mt-1 responsive">
                <p class="font-weight-bold mt-2">₹ {{premcalcDetail.grossPremium == '' ? '0' : premcalcDetail.grossPremium}}</p>
              </div>
              <div class="col-2 mt-0 background  responsive">
                <!-- <p class="font-weight-bold mb-0">₹ {{premcalcDetail.netPremium == '' ? '0' : premcalcDetail.netPremium}}</p> -->
                <P class="font-weight-bold mb-0 mt-2">₹
                  {{parseInt(premcalcDetail.grossPremium)>parseInt(calcbasePremium.premium.premiumBreakup.grossPremium) ? (premcalcDetail.grossPremium)-(calcbasePremium.premium.premiumBreakup.grossPremium) : (calcbasePremium.premium.premiumBreakup.grossPremium)-(premcalcDetail.grossPremium)}}
                </P>
              </div>
            </div>
            <hr class="dash  my-0">
              <div class="row mr-0">
               <div class="col-2 mt-3">
                <p class="premium">GROSS PREMIUM</p>
              </div>
              <div class="col-4 pl-5 mt-3  responsive">
                <p class="font-weight-bold mb-0">₹ {{calcbasePremium.premium.premiumBreakup.netPremium == '' ? '0' : calcbasePremium.premium.premiumBreakup.netPremium}}</p>
                <p class="mb-0 mt-2">utgst <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.utgst == '' ? '0' : calcbasePremium.premium.premiumBreakup.utgst}}</span></p>
                <p class="mb-0">igst <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.igst == '' ? '0' : calcbasePremium.premium.premiumBreakup.igst}}</span></p>
                <p class="">cess <span class="font-weight-bold">{{calcbasePremium.premium.premiumBreakup.cess == '' ? '0' : calcbasePremium.premium.premiumBreakup.cess}}</span></p>
              </div>
               <div class="col-4 mt-3  responsive">
                <p class="font-weight-bold mb-0">₹ {{premcalcDetail.netPremium == '' ? '0' : premcalcDetail.netPremium}}</p>
                <p class="mb-0 mt-2">utgst <span class="font-weight-bold">{{taxDetails.utgst == '' ? '0' : taxDetails.utgst}}</span></p>
                <p class="mb-0">igst <span class="font-weight-bold">{{taxDetails.igst == '' ? '0' : taxDetails.igst}}</span></p>
                <p class="">cess <span class="font-weight-bold">{{taxDetails.cess ? taxDetails.cess : '0'}}</span></p>
              </div>
               <div class="col-2 background rounded-background-bottom  responsive">
                 <P class="font-weight-bold mb-0 mt-3">₹ {{parseInt(premcalcDetail.netPremium)>parseInt(calcbasePremium.premium.premiumBreakup.netPremium) ? (premcalcDetail.netPremium)-(calcbasePremium.premium.premiumBreakup.netPremium) : (calcbasePremium.premium.premiumBreakup.netPremium)-(premcalcDetail.netPremium)}}</P>
              </div>
            </div>
            <hr class='rule my-0 mt-2'>
            <div class="row mr-0 premium mb-0 ml-0 total-premium-row">
              <div class="col-2 mt-3 pl-0">
                <p class="total-premium font-weight-bold">Total Premium</p>
              </div>
              <div class="col-4 mt-3 responsive">
                <p class="font-weight-bold ml-4">₹ {{calcbasePremium.premium.totalPremium}}</p>
              </div>
              <div class="col-4 mt-3 pl-2  responsive">
                <p class="font-weight-bold">₹ {{premcalcDetail.netPremium}}</p>
              </div>
              <div class="col-2 mt-3 total-premium-size  responsive">
                <P class="font-weight-bold mb-0 premium-type">₹ 
                  {{parseInt(premcalcDetail.netPremium)>parseInt(calcbasePremium.premium.totalPremium) ? (premcalcDetail.netPremium)-(calcbasePremium.premium.totalPremium) : (calcbasePremium.premium.totalPremium)-(premcalcDetail.netPremium)}}</P> <span class="premium-size text-ellipsis premium-type-size">{{premiumType}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import FloatLabel from "@/../shared_component/FloatLabel.vue";
import { reactive, computed} from '@vue/composition-api';
export default {
  name: "PremiumBreakdownModal",
  props:['premcalcDetail','showModal','taxDetails','calcbasePremium','premiumType'],
  components: {
  },
  setup(props , { parent, root }){
    let state = reactive({
    });
    function breakdownModal(){
      parent.breakdownModal();
    }
    const isTpPlan = computed(()=>{
      if(root.$store.getters.getMotorParentType.standaloneCPA){
        return false;
      }
      return true;
    });
    return{
      breakdownModal,
      state,
      isTpPlan
    }
  }
};
</script>
<style scoped>
.total-premium-row{
  background-color: rgba(30,30,30,.05);
  min-height: 85px;
  width: 100%;
  margin-left: 0px;
}
.dash{
  border-top: 1px dashed #322f32;
} 
.premium{
  font-size: 14px;
}
.base-premium{
  font-size: 20px;
}
.premium-type-size{
  font-size:10px;
}
.rule{
   border: 1px solid gray;
   width: 100%;
}
.rounded-background-top{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-background-bottom{
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.background{
  background-color: rgba(30,30,30,.05);
}
/* .modal-body{
  padding: 0px;
} */
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.adv-search{
  margin-top: 21px;
  font-size: 14px;
  color: #0872b9;
  font-weight: normal!important;
}
a.bgc-links.adv-search {
  text-decoration: none;
  margin-top: 0px!important;
  line-height: normal;
}
.drop[data-toggle="collapse"]::after{
  content: url(../../../../assets/images/search-up.png);
  padding-left: 9px;
}
.drop[data-toggle="collapse"].collapsed::after{
  content: url(../../../../assets/images/search-down.png);
  padding-left: 9px;
}
#cover_details .col-9:nth-child(4n-3){
  background: rgba(30, 30, 30, 0.1);
}
#cover_details .col-3:nth-child(4n-2){
  background: rgba(30, 30, 30, 0.1);
}
@media (max-width: 575px) {
  .total-premium-size{
  padding-left: 0px;
}
 .premium-size{
    font-size: 14px;
  }
 .premium-type-size{
  font-size:10px;
}
 .premium-type{
  margin-left: 15px;
}

}
@media (max-width: 475px) {
  .premium-size{
    font-size: 12px;
  }
  .total-premium-size{
  padding-left: 0px;
}
.premium{
  font-size: 10px;
}
.premium-type{
  margin-left: 10px;
}
}

@media (max-width: 350px) {
  .premium-size{
    font-size: 14px;
  }
  .base-premium{
  font-size: 10px;
}
  .premium{
  font-size: 10px;
}
  .total-premium-size{
  padding-left: 0px;
}
.responsive{
  font-size: 10px;
}
.premium-type{
  margin-left: 10px;
}
.text-ellipsis{
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 43px;
  margin: 0 auto;
  font-size: 10px;
  -webkit-line-clamp: 3;
  /* -webkit-box-orient: vertical; */
  overflow: hidden;
  text-overflow: ellipsis;
}
}
/* @media (max-width: 350px) {
  .premium-size{
    font-size: 8px;
  }
  .premium{
  font-size: 12px;
}
  .base-premium{
  font-size: 10px;
}
  .total-premium-size{
  padding-left: 0px;
}
} */

/* @media (max-width: 315px) {
  .premium-size{
    font-size: 5px;
  }
  .premium{
  font-size: 6px;
}
  .base-premium{
  font-size: 8px;
}
  .total-premium-size{
  padding-left: 0px;
}
.responsive{
  font-size: 6px;
}
.premium-type{
  margin-left: 0px;
}
} */
</style>